import request from "@/util/request"
import { ApiResponse } from "@/common/model/ApiModel"
import { Order } from "@/order/model/OrderModel"
import { PageResult } from "@/common/model/PageResult"
import { ListActiveOrderReq, ListBuyerSchoolReq } from "@/order/model/req/vendor/ListApiModel"
import type { SchoolOrderCountItem } from "@/order/model/res/vendor/SchoolOrderCountItem"
import type { OrderBuyerSchoolItem } from "@/order/model/res/vendor/OrderBuyerSchoolItem"
import { CheckParam } from "@/order/model/CheckParam"

export function listActive(param: ListActiveOrderReq): Promise<PageResult<Order>> {
  return request.post(`/v2/vendor/order/listActive`, param)
}

export function listCanceled(param: any): Promise<PageResult<Order>> {
  return request.post(`/v2/vendor/order/listCanceled`, param)
}

export function listSchoolOrderCount(param: ListActiveOrderReq): Promise<Array<SchoolOrderCountItem>> {
  return request.post(`/v2/vendor/order/listSchoolOrderCount`, param)
}

/** 反查供应商订单关联的学校（去重），用于订单列表的学校过滤下拉 */
export function listBuyerSchool(param: ListBuyerSchoolReq): Promise<Array<OrderBuyerSchoolItem>> {
  return request.post(`/v2/vendor/order/listBuyerSchool`, param)
}

export function latestCancelRecord(orderId: string): Promise<any> {
  return request.get(`/v2/vendor/order/${orderId}/latestCancelRecord`)
}

export function acceptCancel(orderId: string, param: any): Promise<ApiResponse> {
  return request.post(`/v2/vendor/order/${orderId}/acceptCancel`, param)
}

export function rejectCancel(orderId: string, param: any): Promise<ApiResponse> {
  return request.post(`/v2/vendor/order/${orderId}/rejectCancel`, param)
}

export function acceptCheck(orderId: string, param: CheckParam): Promise<ApiResponse> {
  return request.post(`/v2/vendor/order/${orderId}/acceptAcceptance`, param)
}
